import { type Components, type Paths } from '@webapp/api/integrations/client'
import { IntegrationLocalEntities } from '@webapp/platform/integrations/entities/enums/IntegrationLocalEntityEnum'

export type IntegrationEntity = Components.Schemas.SyncRequest['entity']
export type SyncHistory = Paths.ListSync.Responses.$200
export type SyncHistoryRecord = SyncHistory[0]

type LOCAL_ENTITY_KEYS =
  | 'BILL'
  | 'VENDOR'
  | 'PAYMENT'
  | 'PURCHASE_ORDER_ITEM'
  | 'BILL_ITEM'
  | 'PURCHASE_ORDER'
  | 'TENANT'
  | 'CURRENCY'
  | 'TAX'
  | 'ACCOUNT_CODE'
  | 'PAYMENT_ITEM'
  | 'REPORT_FIELD'
  | 'NULL'
  | 'BILL_ATTACHMENT'
  | 'REFERENCE_BILL'
  | 'SPENDING_CARD_TRANSACTION'
  | 'ATTACHMENT'
  | 'REPORT_FIELD_VALUE'

type IntegrationLocalEntityRecord = {
  [key in LOCAL_ENTITY_KEYS]: IntegrationEntity
}
const produceIntegrationLocalEntity = <T extends IntegrationLocalEntityRecord>(
  x: T
) => x

export const IntegrationEntities = produceIntegrationLocalEntity({
  VENDOR: IntegrationLocalEntities.VENDOR,
  BILL: IntegrationLocalEntities.BILL,
  PAYMENT: IntegrationLocalEntities.PAYMENT,
  PURCHASE_ORDER_ITEM: IntegrationLocalEntities.PURCHASE_ORDER_ITEM,
  BILL_ITEM: IntegrationLocalEntities.BILL_ITEM,
  PURCHASE_ORDER: IntegrationLocalEntities.PURCHASE_ORDER,
  TENANT: IntegrationLocalEntities.TENANT,
  CURRENCY: IntegrationLocalEntities.CURRENCY,
  TAX: IntegrationLocalEntities.TAX,
  ACCOUNT_CODE: IntegrationLocalEntities.ACCOUNT_CODE,
  PAYMENT_ITEM: IntegrationLocalEntities.PAYMENT_ITEM,
  NULL: IntegrationLocalEntities.NULL,
  REPORT_FIELD: IntegrationLocalEntities.REPORT_FIELD,
  BILL_ATTACHMENT: IntegrationLocalEntities.BILL_ATTACHMENT,
  REFERENCE_BILL: IntegrationLocalEntities.REFERENCE_BILL,
  SPENDING_CARD_TRANSACTION: IntegrationLocalEntities.TRANSACTION,
  ATTACHMENT: IntegrationLocalEntities.ATTACHMENT,
  REPORT_FIELD_VALUE: IntegrationLocalEntities.REPORT_FIELD_VALUE,
})
